import React, { useState, useEffect } from 'react';
import api from '../../../config/axios';
import Swal from 'sweetalert2';

import { FaPlus, FaMinus, FaAngleDown, FaAngleUp, FaRegSave } from 'react-icons/fa';

const FormulariosPerguntas = () => {
    const [error, setError] = useState(null);

    const [formularios, setForms] = useState([]);
    const [selectedForm, setSelectedForm] = useState('');
    const [perguntasDisponiveis, setPerguntasDisponiveis] = useState([]);
    const [perguntasAtribuidas, setPerguntasAtribuidas] = useState([]);

    const getFormularios = async () => {
        Swal.fire({
            title: 'Carregando...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const response = await api.get(`/anamnese-formularios`);

            setForms(response.data.records || []);
            setSelectedForm(response.data.records[0].id);
            handleFormChange({ target: { value: response.data.records[0].id } });
            setError(null);
        } catch (err) {
            setError('Erro ao carregar os formulários.');
        } finally {
            Swal.close();
        }
    };

    const handleFormChange = async (e) => {
        const formId = e.target.value;
        setSelectedForm(formId);

        try {
            const response = await api.get(`/anamnese-formularios/details/${formId}`);

            setPerguntasDisponiveis(response.data.perguntas.records);
            setPerguntasAtribuidas(response.data.formularioPerguntas.records);
            setError(null);
        } catch (err) {
            setError('Erro ao carregar os formulários.');
        }

    };

    const handleMoveUp = (index) => {
        if (index === 0) return;
        setPerguntasAtribuidas((prevAtribuidas) => {
            const updated = [...prevAtribuidas];
            [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];
            return updated;
        });
    };

    const handleMoveDown = (index) => {
        if (index === perguntasAtribuidas.length - 1) return;
        setPerguntasAtribuidas((prevAtribuidas) => {
            const updated = [...prevAtribuidas];
            [updated[index], updated[index + 1]] = [updated[index + 1], updated[index]];
            return updated;
        });
    };

    const handleAddQuestion = (question) => {
        setPerguntasDisponiveis((prevDisponiveis) =>
            prevDisponiveis.filter((q) => q.id !== question.id)
        );
        setPerguntasAtribuidas((prevAtribuidas) => [...prevAtribuidas, question]);
    };

    const handleRemoveQuestion = (question) => {
        setPerguntasAtribuidas((prevAtribuidas) =>
            prevAtribuidas.filter((q) => q.id !== question.id)
        );
        setPerguntasDisponiveis((prevDisponiveis) => [...prevDisponiveis, question]);
    };

    const handleSubmit = async () => {
        const form = {};
        form.data = [];
        for (let i = 0; i < perguntasAtribuidas.length; i++) {
            form.data.push({
                id_ordem_pergunta: i + 1,
                id_pergunta: perguntasAtribuidas[i].id
            })
        }

        form.id_formulario = selectedForm;

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            await api.post(`/anamnese-formulario-pergunta`, form);

            Swal.fire('Sucesso', 'Perguntas atribuídas com sucesso!', 'success');
        }
        catch (error) {
            Swal.close();
            Swal.fire('Erro', `${error.response.data.message}`, 'error');
        }
    };

    useEffect(() => {
        getFormularios();
    }, []);

    function tipoPerguntaLabel(tipo) {
        switch (tipo) {
            case '01': return 'Texto';
            case '02': return 'Múltipla Escolha';
            case '03': return 'Escolha Única';
            case '04': return 'Caixa de Seleção';
            case '05': return 'Área de Texto';
            case '06': return 'Arquivo';
            case '07': return 'Faixa de Valores';
        }
    };

    return (
        <div className="container-fluid">
            <div className="card">
                <div className="card-body">
                    <div className="row mt-3">
                        <div className="col-12">
                            <h4 className="fw-bold">Formulários x Perguntas</h4>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-4 col-12">
                            <label className="form-label fw-bold">Formulário</label>
                            <select
                                name="formulario"
                                className="form-control"
                                value={selectedForm}
                                onChange={handleFormChange}
                            >
                                <option value="" hidden>Selecione...</option>
                                {formularios.map((form) => (
                                    <option key={form.id} value={form.id}>
                                        {form.ds_formulario}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {selectedForm && (
                        <div className="row mt-4">
                            {perguntasDisponiveis.length > 0 && (
                                <div className="col-xl-6 col-12">
                                    <h5 className="fw-bold">Perguntas Disponíveis</h5>
                                    <div className="table-responsive max-h-400">
                                        <table className="table table-striped">
                                            <thead className="table-custom-primary">
                                                <tr className="thead-fixed">
                                                    <th>Enunciado</th>
                                                    <th>Tipo</th>
                                                    <th className="text-center">Ações</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {perguntasDisponiveis.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="3" className="text-center">
                                                            Nenhuma pergunta disponível.
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    perguntasDisponiveis.map((pd) => (
                                                        <tr key={pd.id}>
                                                            <td className="text-nowrap">{pd.ds_enunciado}</td>
                                                            <td className="text-nowrap">{tipoPerguntaLabel(pd.tp_pergunta)}</td>
                                                            <td className="text-center">
                                                                <button
                                                                    className="btn btn-custom-secondary btn-sm"
                                                                    onClick={() => handleAddQuestion(pd)}
                                                                >
                                                                    <FaPlus />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                            {perguntasAtribuidas.length > 0 && (
                                <div className="col-xl-6 col-12 mt-xl-0 mt-4">
                                    <h5 className="fw-bold">Perguntas Atribuídas</h5>
                                    <div className="table-responsive max-h-400">
                                        <table className="table table-striped">
                                            <thead className="table-custom-primary">
                                                <tr className="thead-fixed">
                                                    <th>Enunciado</th>
                                                    <th>Tipo</th>
                                                    <th>Ordem</th>
                                                    <th className="text-center">Ações</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {perguntasAtribuidas.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="4" className="text-center">
                                                            Nenhuma pergunta atribuída.
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    perguntasAtribuidas.map((pa, index) => (
                                                        <tr key={pa.id}>
                                                            <td className="text-nowrap">{pa.ds_enunciado}</td>
                                                            <td className="text-nowrap">{tipoPerguntaLabel(pa.tp_pergunta)}</td>
                                                            <td className="text-nowrap">{index + 1}</td>
                                                            <td className="text-nowrap text-center">
                                                                <button
                                                                    className="btn btn-custom-secondary btn-sm me-3"
                                                                    onClick={() => handleMoveUp(index)}
                                                                    disabled={index === 0}
                                                                >
                                                                    <FaAngleUp />
                                                                </button>
                                                                <button
                                                                    className="btn btn-custom-secondary btn-sm me-3"
                                                                    onClick={() => handleMoveDown(index)}
                                                                    disabled={index === perguntasAtribuidas.length - 1}
                                                                >
                                                                    <FaAngleDown />
                                                                </button>
                                                                <button
                                                                    className="btn btn-custom-secondary btn-sm"
                                                                    onClick={() => handleRemoveQuestion(pa)}
                                                                >
                                                                    <FaMinus />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    {selectedForm && (
                        <div className="row mt-3">
                            <div className="col-12 text-end">
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FormulariosPerguntas;
